import { WHATSAPP_NUMBER, TID } from "@/lib/testIds";
import { motion } from "framer-motion";

const WhatsAppFab = () => (
  <motion.a
    href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
      "Hi MSMEmoney, I'd like to discuss my MSME requirement."
    )}`}
    target="_blank"
    rel="noreferrer noopener"
    aria-label="Chat on WhatsApp"
    data-testid={TID.wa}
    initial={{ opacity: 0, scale: 0.6 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 2.4, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
    className="fixed bottom-5 right-5 z-40 group"
  >
    <span className="absolute inset-0 bg-[#25D366] rounded-full blur-lg opacity-40 group-hover:opacity-60 transition-opacity" />
    <span className="relative grid h-14 w-14 md:h-16 md:w-16 place-items-center rounded-full bg-[#25D366] text-white shadow-lg ring-1 ring-black/20 hover:scale-105 transition-transform">
      <svg viewBox="0 0 32 32" className="h-7 w-7" fill="currentColor" aria-hidden>
        <path d="M19.11 17.28c-.29-.14-1.72-.85-1.99-.95-.27-.1-.46-.14-.66.14-.19.29-.75.95-.92 1.14-.17.19-.34.22-.63.07-.29-.14-1.22-.45-2.32-1.43-.86-.77-1.44-1.71-1.61-2-.17-.29-.02-.44.13-.59.13-.13.29-.34.43-.51.14-.17.19-.29.29-.48.1-.19.05-.36-.02-.5-.07-.14-.66-1.58-.9-2.16-.24-.58-.48-.5-.66-.51h-.56c-.19 0-.5.07-.76.36-.26.29-1 .98-1 2.39s1.02 2.77 1.16 2.96c.14.19 2.01 3.07 4.87 4.31.68.29 1.21.47 1.63.6.68.22 1.31.19 1.8.12.55-.08 1.72-.7 1.96-1.38.24-.68.24-1.27.17-1.38-.07-.12-.26-.19-.55-.34zM16.02 5.33c-5.9 0-10.68 4.78-10.68 10.67 0 1.88.49 3.71 1.42 5.33L5 27l5.83-1.53c1.56.85 3.32 1.3 5.13 1.3h.06c5.89 0 10.68-4.78 10.68-10.67 0-2.85-1.11-5.53-3.13-7.55a10.62 10.62 0 0 0-7.55-3.22zm0 19.34a8.65 8.65 0 0 1-4.42-1.21l-.32-.19-3.46.91.92-3.37-.21-.34a8.63 8.63 0 0 1-1.33-4.63c0-4.78 3.9-8.67 8.68-8.67a8.63 8.63 0 0 1 6.13 2.54 8.63 8.63 0 0 1 2.54 6.13c-.01 4.78-3.9 8.83-8.53 8.83z" />
      </svg>
    </span>
  </motion.a>
);

export default WhatsAppFab;
